import MasterServices from './master';

export default {
    ...MasterServices
};
